module.exports = __webpack_public_path__ + "static/media/02 Minutes of Meeting 08 JUNE 2023.81cfa8ca.pdf";